/* eslint-disable @typescript-eslint/naming-convention */
import {
  IOrderSummaryResponse,
} from '../../IApiResponses';
import { IOrderSummary } from '../../IDataMappings';

const orderSummaryMapper = {
  response(orderSummary: IOrderSummaryResponse): IOrderSummary {
    return {
      codSurchargeAmount: orderSummary.cod_surcharge_amount,
      currencyCode: orderSummary.currency_code,
      discount: orderSummary.total_items_discount,
      estimatedDeliveryEndDate: orderSummary.estimated_delivery_end_date,
      estimatedDeliveryStartDate: orderSummary.estimated_delivery_start_date,
      formattedTaxRate: orderSummary.formatted_tax_rate,
      giftCardTotal: orderSummary.gift_card_payment_amount,
      giftWrapTotal: orderSummary.total_giftwrap_applied_price,
      isGiftWrap: orderSummary.giftWrap,
      itemsCount: orderSummary.items_count,
      retailDeliveryFeeMessage: orderSummary.retail_delivery_fee_message,
      rewardPointsPriceInCartFormatted: orderSummary.rewardPointsPriceInCartFormatted,
      subTotal: orderSummary.total_items_base_price,
      subTotalWithoutDonations: orderSummary.subtotal_without_donations,
      taxIsEstimated: !!orderSummary.tax_is_estimated,
      taxRate: orderSummary.tax_rate,
      totalAppliedTax: orderSummary.total_applied_tax,
      totalCost: orderSummary.total_cost,
      totalDonations: orderSummary.total_donations,
      totalIncludedTax: orderSummary.total_included_tax,
      totalRetailDeliveryFee: orderSummary.total_retail_delivery_fee,
      totalShippingPrice: orderSummary.total_shipping_applied_price,
    };
  },
};

export default orderSummaryMapper;